export const PHARMACY_POS_ROLE_ID = 20;

export const isPharmacyPosOnlyRole = (role) =>
  Number(role) === PHARMACY_POS_ROLE_ID;

export const getAdminHomePath = (role) => {
  const normalizedRole = Number(role);

  if (normalizedRole === PHARMACY_POS_ROLE_ID) {
    return "/admin/pharmacy-pos";
  }

  if (normalizedRole === 18 || normalizedRole === 19) {
    return "/admin/order_list";
  }

  return "/admin/dashboard";
};
